declare const dataLayer:any[];

export function postConversion(eventName: string) {
    if(!dataLayer || !dataLayer[0] || !dataLayer[0].facebookId) return;

    fetch(`/api/express/tracking/${dataLayer[0].facebookId}`, {
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({eventName: eventName, eventSourceUrl: window.location.href})
    });
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function gtag(...args: any) {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
}
